<template>
  <div class="home">
    <div class="hero">
      <div class="hero-content">
        <div class="heading">
          <h1>Karanteenin Joulu</h1>
          <h3>Jouluisaa tunnelmaa joulukalenterin muodossa</h3>
          <router-link to="/kalenteri">
            <a class="button">Joulukalenteri</a>
          </router-link>
        </div>
        <div class="hero-background">
          <img :src="require('@/assets/jouluhero.jpg')" alt />
        </div>
        <Snowfall
          :amount="50"
          :size="5"
          :speed="1.5"
          :wind="0"
          :opacity="1"
          :swing="1"
          :image="null"
          :zIndex="null"
          :resize="true"
          color="#f0f4f9"
        />
      </div>
    </div>
    <main>
      <div class="pagecontent">
        <div class="container highlight">
          <h3 class="content">Kaikki joulun tiedot yhdestä paikasta</h3>
          <p
            class="content"
          >Karanteenissa joulua vietetään pitkin joulukuuta joulukalenterin muodossa.</p>
          <p class="content">
            Kaikki huipentuu
            <strong>lauantaina 21.12.2019</strong> tapahtumarikkaan joulujuhlan merkeissä.
          </p>
        </div>
        <div class="container currentdoor" v-if="calendarDoor">
          <h2>Päivän kuvaluukku</h2>
          <CalendarDoor
            :year="calendarDoor.year"
            :month="calendarDoor.month"
            :doornumber="calendarDoor.day"
            :image="calendarDoor.filename"
            :message="calendarDoor.message ? calendarDoor.message : 'Sieltä se joulu tulla tupsahtaa'"
            :heading="calendarDoor.heading ? calendarDoor.heading : 'Sieltä se joulu tulla tupsahtaa'"
            showCompleteMessage
          />
        </div>
        <div class="container">
          <h3>Tämän sivun tarkoitus</h3>
          <p
            class="content"
          >Tälle sivulle kerätään kaikki uusi ja julkaistu jouluun liittyvä tieto helpottamaan asioiden löytämistä ja muistamista.</p>
          <h3>Aikataulu</h3>
          <p class="content">
            Tulevien tapahtumien päivämäärät ja tapahtuma-ajat löytyvät aina ajankohtaiseksi päivitettynä&nbsp;
            <router-link to="/aikataulu">aikataulu</router-link>&nbsp;sivulta.
          </p>
          <h3>Tapahtumapaikka</h3>
          <p class="content">Joulun tapahtumapaikkana toimii tonttujen joulukylä.</p>
          <img class="styled" :src="require('@/assets/village_alt.jpg')" alt />
          <p class="content">
            <strong>/warp joulu</strong> vie paikan päälle.
          </p>
          <p class="content">Kaikki joulukalenterin luukut löytyvät tonttukylästä.</p>
          <h3>Kalenteriluukut</h3>
          <p
            class="content"
          >Joka päivä tonttukylästä aukeaa yhden rakennuksen ovi. Sinun tehtäväsi on etsiä rakennuksista nappi ja painaa sitä. Vastaa annettuun kysymykseen oikein ja voitat palkinnon! Jos "avaat" kaikki 24 luukkua, niin saat uuden palikan taikamattoon!</p>
          <p class="content">
            Luukkuja voi avata päivään
            <strong>28.12.2019</strong> asti, jonka jälkeen kaikki luukut lukittuvat.
          </p>
          <h3>Kuvaluukut</h3>
          <p class="content">
            Palvelimen kalenteriluukkuja viitoittamassa&nbsp;
            <router-link to="/kalenteri">kuvakalenteri</router-link>&nbsp;sivulla aukeaa kuvaluukkuja, joiden takaa löytyy päivään liittyviä kuvia, sekä mahdollisia vinkkejä tai tietoiskuja.
          </p>
          <h3>Joulujuhlat</h3>
          <p class="content">
            Joulujuhlat ovat
            <strong>lauantaina 21.12.</strong>, jossa luvassa on kaikkea piirtokisasta lumisotaan!
          </p>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import Snowfall from "vue-snowf";
import CalendarDoor from "@/components/CalendarDoor.vue";

export default {
  name: "Home",
  components: {
    CalendarDoor,
    Snowfall
  },
  data() {
    return {
      calendarDoor: null
    };
  },
  created() {
    this.fetchCurrentCalendarDoor();
  },
  methods: {
    fetchCurrentCalendarDoor() {
      this.error = this.post = null;
      this.loading = true;
      axios
        .get(".netlify/functions/currentDoor")
        .then(response => {
          this.loading = false;

          if (!response.data) {
            return;
          } else if (response.data.noCurrentDoor === true) {
            return;
          }
          this.calendarDoor = response.data;
        })
        .catch(e => {
          this.loading = false;
          this.error = e;
        });
    }
  }
};
</script>

<style scoped>

.home {
  position: relative;
}

.highlight {
  margin-top: 0.4em;
}

.highlight p {
  font-weight: 300 !important;
  letter-spacing: 0.2px;
  margin: 0;
  margin-bottom: 0.2em;
}

.highlight h3 {
  line-height: 1.1;
  margin-bottom: 0.3em;
  font-size: 2em;
  font-weight: 300;
}

>>> .snowf-canvas {
  pointer-events: none;
}

.container {
  max-width: 750px;
}

.hero {
  height: 680px;
  max-height: 80vh;
  display: flex;
  z-index: 1;
  position: relative;
}

img.styled {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  max-height: 300px;
}

.pagecontent {
  margin-top: calc(-5em + 2vw);
  z-index: 2;
  position: relative;
}

.content img {
  margin: 1em 0;
  margin-top: 0.3em;
}

.hero-content {
  z-index: 2;
  box-sizing: content-box;
  margin: 0 auto;
  position: relative;
  flex: 1 1 auto;
  display: flex;
  justify-content: center;
  color: white;
  background-color: #171b31;
  mask-image: url("~@/assets/curvewhitespace.svg");
  mask-repeat: no-repeat;
  mask-size: cover;
  mask-position: center;
}

.hero-background {
  align-items: center;
  background-color: #171b31;
  display: flex;
  justify-content: center;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: -1;
}

.hero-background img {
  flex: 0 0 auto;
  width: 100%;
  height: 660px;
  object-fit: cover;
  margin-top: -5px;
  max-width: initial;
  mix-blend-mode: color-dodge;
}

.heading {
  margin: 10rem 0 10rem 0;
  padding: 0 2em;
}

.heading h1 {
  font-size: 4em;
  letter-spacing: -1px;
  margin: 0;
  text-align: center;
  line-height: 0.8;
  margin-bottom: 0.23em;
  color: white;
}

.heading h3 {
  font-size: 1.59em;
  margin: 0;
  font-weight: 300;
  color: white;
}

.heading .button {
  margin-top: 2rem;
}

img {
  max-width: 100%;
}

.currentdoor {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 1.5em calc(1em + 4vw);
  background-color: hsla(222, 32%, 93%, 1);
  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  max-width: none;
  box-sizing: border-box;
  margin-top: 4em;
}

.currentdoor h2 {
  font-size: 1.5em;
  font-weight: 600;
  margin: 0;
}

@media screen and (max-width: 700px) {
  .heading {
    font-size: calc(0.4em + 1.1vw);
    margin-top: 8.5rem;
  }

  .hero {
    height: 570px;
  }
}

@media screen and (max-width: 950px) {
  .highlight p:nth-child(2) {
    margin-bottom: 0.3em;
  }

}
</style>
